import React from "react";

import { HeaderSlot, PAGE_TITLE_SLOT_ID } from "shared/ui/HeaderSlot";

/*
* Заголовок страницы в шапке. Ставит его страница-обёртка, а не фича (правило раскладки фич):
* обёртка знает, как экран называется, а фича — что на нём происходит.
* */
export const PageTitle = ({ children }: { children: React.ReactNode }) => (
    <HeaderSlot slotId={PAGE_TITLE_SLOT_ID}>{children}</HeaderSlot>
);
